import { ListItemProps, ListItem as MuiListItem } from '@mui/material';

type Props = Pick<ListItemProps, 'children' | 'className' | 'secondaryAction' | 'sx'>;

const ListItem = ({ children, className, secondaryAction, sx }: Props) => {
  return (
    <MuiListItem
      disableGutters
      disablePadding
      className={className}
      secondaryAction={secondaryAction}
      sx={sx}
    >
      {children}
    </MuiListItem>
  );
};

export default ListItem;
